// order alphabatically
export const GENERIC_CONSTANT = {
  dato_cms_url: `https://dato.wikijob.co.uk/editor/item_types`,
  hellobar_button_url: `https://tests.wikijob.co.uk/hello-bar?tid2=hellobar`,
  link_psychometric_success: `https://link.psychometric-success.com`,
  practice_aptitude_text: `Don't lose out on that job. Practice aptitude tests today.`,
  psychometric_success:`https://psychometric-success.com/aptitude-tests/test-types`
}
